import styled from 'styled-components';
import { Button } from '../../../../input/Button';

export const SiteButton = styled(Button)
    .withConfig({ displayName: 'SiteButton' })
    .attrs((props) => ({
        ...props,
        color: props.color,
        variant: 'filled',
        size: 'm',
        width: '100%',
        minHeight: '40px',
    }))``;
